// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"488":"a38e705a","814":"e1c4d6ab","816":"50a49616"}[chunkId] + ".css";
};